// extracted by css-extract-rspack-plugin
export default {"table":"qMhZV","cell":"oWW81","headerCell":"VYJmS","row":"ULqiB","entityNameLink":"XHGVa"};